import React from 'react'
import VpnKey from '@mui/icons-material/VpnKey'
import HelpOutline from '@mui/icons-material/HelpOutline'

interface IMemberType {
  labelId: string
  icon: React.JSX.Element
}

const API_ACCOUNT_TYPE: IMemberType = {
  labelId: 'common.memberTypes.openApiAccount',
  icon: <VpnKey style={{ fontSize: 16 }} />
}

const OTHER_TYPE: IMemberType = {
  labelId: 'common.memberTypes.other',
  icon: <HelpOutline style={{ fontSize: 16 }} />
}

// Users are shown with their initials, so they have no member type entry.
// Anything that is neither a user nor an API account (groups, service
// principals, …) is grouped under "Other". A missing principalType is treated
// as a user, as members added in forms don't carry one.
export const getMemberType = (principalType?: string) => {
  if (!principalType || principalType === 'UserIdentity') {
    return undefined
  }
  return principalType === 'OpenAPIAccount' ? API_ACCOUNT_TYPE : OTHER_TYPE
}

export const getMemberTypeLabelId = (principalType?: string) =>
  getMemberType(principalType)?.labelId || 'common.memberTypes.user'
